module.exports = __webpack_public_path__ + "img/collection.b27cd79c.png";